import React, { useState } from "react";

import { Col, Row, Layout } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as Files } from "shared/assets/Files.svg";
import { ReactComponent as Plus } from "shared/assets/Plus.svg";
import { ReactComponent as User } from "shared/assets/User.svg";
import { ReactComponent as ContactUs } from "shared/assets/Vector.svg";
import Header from "shared/components/Header";
import Menu from "shared/components/Menu";
import { NAME_SPACES } from "shared/locals/constants";
import { PATHS } from "utils/constants";
import { useInfo } from "utils/hooks/info";

import ContactModal from "./Contact";
import "./styles.scss";

const { Content } = Layout;

const Component = (WrappedComponent) => {
  const PrivateLayout = (props) => {
    const {
      commonInfo,
      customerInfo: { fullname },
    } = useInfo();
    const [isVisble, setIsVisible] = useState(false);
    const history = useHistory();
    const { pathname: currentPath } = useLocation();
    const { t } = useTranslation(NAME_SPACES.LAYOUT);

    const MENU_ITEMS = [
      {
        key: PATHS.FILE.HOME,
        text: t("FOLDERS"),
        icon: <Files />,
        onClick: () => onNavigate(PATHS.FILE.HOME),
        disabled: !commonInfo.knownCustomer,
      },
      {
        key: PATHS.FILE.NEW,
        text: t("NEW"),
        icon: <Plus />,
        onClick: () => onNavigate(PATHS.FILE.NEW),
        disabled: !commonInfo.knownCustomer,
      },
      {
        key: PATHS.FILE.CONTACTUS,
        text: t("CONTACT"),
        icon: <ContactUs />,
        onClick: () => onNavigate(PATHS.FILE.CONTACTUS),
      },
      {
        key: "Contact",
        text: t("ACCOUNT"),
        icon: <User />,
        onlyMobile: true,
        onClick: () => setIsVisible(true),
        disabled: !commonInfo.knownCustomer,
      },
    ];

    const onNavigate = (nextPath) => {
      currentPath === nextPath
        ? window.location.reload()
        : history.push(nextPath);
    };

    return (
      <Layout className="layout-wrapper">
        <Content className="layout">
          <div className="container">
            <Header />
            <Row gutter={[32, 0]}>
              <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                <Menu
                  items={MENU_ITEMS}
                  selected={currentPath === "/" ? PATHS.FILE.HOME : currentPath}
                />
              </Col>
              <Col xxl={18} xl={18} lg={18} sm={24} xs={24}>
                <WrappedComponent {...props} />
              </Col>
            </Row>
          </div>
        </Content>
        <ContactModal
          title={fullname}
          isVisible={isVisble}
          onClose={() => setIsVisible(false)}
        />
      </Layout>
    );
  };

  return PrivateLayout;
};

export default Component;
